import { render, staticRenderFns } from "./product-cleaning-drone.vue?vue&type=template&id=2a81ad3b&scoped=true"
import script from "./product-cleaning-drone.vue?vue&type=script&lang=js"
export * from "./product-cleaning-drone.vue?vue&type=script&lang=js"
import style0 from "./product-cleaning-drone.vue?vue&type=style&index=0&id=2a81ad3b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a81ad3b",
  null
  
)

export default component.exports